import { render } from "./FinishField.vue?vue&type=template&id=50500af6&scoped=true"
import script from "./FinishField.vue?vue&type=script&lang=js"
export * from "./FinishField.vue?vue&type=script&lang=js"

import "./FinishField.vue?vue&type=style&index=0&id=50500af6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50500af6"]])

export default __exports__